/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { Badge } from 'reactstrap';

export interface StatusBadgeConfig {
  color: string;
  icon: string;
  label: string;
}

interface StatusBadgeProps {
  config: StatusBadgeConfig;
  minWidth?: number;
}

export const StatusBadge = ({ config, minWidth }: StatusBadgeProps) => {
  return (
    <Badge
      color={config.color}
      className='d-inline-flex align-items-center justify-content-center gap-1'
      style={minWidth ? { minWidth } : undefined}
    >
      {config.icon ? <i className={`fa ${config.icon}`} /> : null}
      <span>{config.label}</span>
    </Badge>
  );
};
